module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Strada_Sdrucciolevole-BN.53e339a7.svg";